export default __webpack_public_path__ + "static/media/online-classroom-47-2-540x482.3da2532b.png";